import { makeAutoObservable } from "mobx";
import { UploadType } from "../../static/enums/UploadType";

class UploadFilesUi {
  private loading: boolean = false;
  private process: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  get isLoading() {
    return this.loading;
  }

  setIsLoading = (isLoading: boolean) => {
    this.loading = isLoading;
  };

  get loadProcess() {
    return this.process;
  }

  setLoadProcess = (process: number) => {
    this.process = process;
  };
}

function createCachedUploadFilesUi() {
  const cache: { [K in UploadType]?: UploadFilesUi } = {};
  return (type: UploadType) => {
    if (!cache[type]) {
      cache[type] = new UploadFilesUi();
    }
    return cache[type] as UploadFilesUi;
  };
}

export const getCachedUploadFilesUi = createCachedUploadFilesUi();
